import React from 'react'
import {get} from 'lodash'

class EmbedWall extends React.Component {

  render() {
    const siteLogo = get(window.settings, 'images.desktopLogo')
    const domainName = get(window.settings, 'domainName')
    const contentUrl = "//"+domainName + get(this.props, 'videoGist.permalink')

    if (window.SERVER_SIDE_RENDERING) {
      return <div className="embed-wall-prompt"></div>
    }
    
    return (
      <div className="embed-wall-prompt">
        <div className="overlay">
            <img src={siteLogo} alt="site logo" className="siteLogo"/>
            {!this.props.embedPlayable && <h3>FORBIDDEN!</h3>}
            {!this.props.embedPlayable && <p>Embed not allowed to play here, go <a href={contentUrl} target="_blank">HERE</a> to watch the content.</p>}
            {this.props.embedPlayable && <p>Click <a href={contentUrl} target="_blank">HERE</a> to watch the content.</p>}
            <div className="poweredBy">
                Powered by <a target="_blank" href="https://www.viewlift.com">Viewlift</a>
            </div>
        </div>
      </div>
    )
  }
}

export default EmbedWall;
